import { useGetIdentity, useList } from '@pankod/refine-core'

import { Menu, Icons } from '@pankod/refine-antd'

import { IGrade, IQuestionType, ISubject, ITeacherLevel, IQuestionStatus, IWorkRequestStatus } from 'interfaces'
import { useEffect, useState } from 'react'
const { AppstoreOutlined, FilterOutlined } = Icons
type FilterProps = {
  changeFilters: any
  source: string
}
export const DraftQuestionFilter: React.FC<FilterProps> = ({ changeFilters, source }) => {
  const gradeList = useList<IGrade>({
    resource: 'grades',

    metaData: {
      fields: ['id', 'name'],
    },
    config: {
      sort: [{ order: 'asc', field: 'name' }],
      pagination: { current: 1, pageSize: 20 },
    },
  })

  const subjectList = useList<ISubject>({
    resource: 'subjects',
    metaData: {
      fields: ['id', 'name'],
    },
    config: {
      sort: [{ order: 'asc', field: 'name' }],
      pagination: { current: 1, pageSize: 100 },
    },
  })
  // const teacherLevelList = useList<ITeacherLevel>({
  //   resource: "teacher_levels",
  //   metaData: {
  //     fields: ["id", "name"],
  //   },
  //   config: {
  //     sort: [{ order: "asc", field: "name" }],
  //   },
  // });
  //  Filter Array : Add the filters here

  const questionFilters = [
    {
      menuName: `All ${source}`,
      key: 'all',
      isLeaf: false,
      options: [],
      filterKey: 'all',
      filterOp: '',
    },
    {
      menuName: 'Grade',
      key: 'grade',
      isLeaf: true,
      options: gradeList?.data?.data,
      filterKey: 'question_grades.grade_id',
      filterOp: 'eq',
    },
    {
      menuName: 'Subject',
      key: 'subject',
      isLeaf: true,
      options: subjectList?.data?.data,
      filterKey: 'subject_id',
      filterOp: 'eq',
    },
    // {
    //   menuName: "Teacher Level",
    //   key: "teacherlevel",
    //   isLeaf: true,
    //   options: teacherLevelList?.data?.data,
    //   filterKey: "teacher_level_id",
    //   filterOp: "eq",
    // },
  ]
  return (
    <div className="ams-filter-bar">
      <Menu mode="horizontal" defaultSelectedKeys={['all']} className="ams-filter-menu">
        {questionFilters?.map((item, idx) =>
          !item?.isLeaf ? (
            <>
              <Menu.Item key={`${item?.key}${idx}`} icon={<AppstoreOutlined />} onClick={() => changeFilters(item?.filterKey, '', '')}>
                {item?.menuName}
              </Menu.Item>
            </>
          ) : (
            <>
              <Menu.SubMenu key={`${item?.key}${idx}`} title={item?.menuName} icon={<FilterOutlined />}>
                {item?.options?.map((options, idx) => (
                  <Menu.Item
                    key={`${options.name}${idx}`}
                    icon={<AppstoreOutlined />}
                    onClick={() => changeFilters(item?.filterKey, options?.id, item?.filterOp)}
                  >
                    {options.name}
                  </Menu.Item>
                ))}
              </Menu.SubMenu>
            </>
          )
        )}
      </Menu>
    </div>
  )
}
